module.exports = __webpack_public_path__ + "static/FBForWeb-8b3c68c60f891a1048d9975feb646f7b.png";